import { takeLatest } from 'redux-saga/effects';
import { FETCH_STOCK_WAREHOUSE } from '../../redux/modules/stockWarehouse/stockWarehouse-actions';
import { fetchPagesOfStockWarehouseWorker } from './stockWarehouseWorkerSaga';

// eslint-disable-next-line import/prefer-default-export
export function* fetchPagesOfStockWarehouseWatcher() {
    yield takeLatest(FETCH_STOCK_WAREHOUSE, fetchPagesOfStockWarehouseWorker);
}
